var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"header__text"},[_vm._v("\n  “AIオールイン”で創る "),_c('br'),_vm._v("\n  Delight\n")])
}]

export { render, staticRenderFns }